import { CaseSpecification } from '../../../CaseSpecification';

export const setCaseBasementsLevelsCount =
  (requestedCount?: number) =>
  (caseSpecification: CaseSpecification): CaseSpecification => ({
    ...caseSpecification,
    basementLevelsCount: requestedCount
  });
